// extracted by mini-css-extract-plugin
export var contrastLow = "_3h-1";
export var externalLink = "_3h-2";
export var externalLinkIcon = "_3h-3";
export var link = "_3h-0";
export var linkLabel = "_3h-4";